export enum IntelligentEscalationType {
  PROPERTY_QUESTION = 'Property Question',
  SELF_SHOWING_INSTRUCTIONS_REQUEST = 'Self Showing Instructions Request',
  PHONE_CALL_REQUEST = 'Phone Call Request',
  OTHER_PROPERTIES_CALL_REQUEST = 'Other Properties Call Request',
}
